import styled from 'styled-components';

/** The finished ad's holder; VideoReveal's loop writes its mask, filter and transform while it reveals. */
export const Holder = styled.div`
  width: 100%;
  transform-origin: 50% 50%;
`;
